.integrationModal {
	.content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0px;
		color: #6c757d;

		&.inProcess {
			font-weight: 500;
			color: #7fb02f;
		}

		&.complete {
			font-weight: 500;
			color: black;
		}

		.checkIcon {
			width: 1.5em;
			height: 1.5em;
		}

		.successIcon {
			color: #1f9d55;
		}

		.errorIcon {
			color: #dc2626;
		}
	}

	.syncMessageList {
		margin: 6px 0 0;
		padding-left: 18px;
		font-size: 12px;
		line-height: 1.45;
		color: #dc2626;
		word-break: break-word;

		li + li {
			margin-top: 4px;
		}
	}
}
